import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.space16,
  },
  currentImage: {
    height: 100,
    objectFit: "contain",
  },
  textContainer: {
    display: "flex",
    padding: "0 16px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.space8,
    alignSelf: "stretch",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space2,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
  },
  achievementTitle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignSelf: "stretch",
    height: "30px",
    fontStyle: "normal",
    letterSpacing: "-0.9px",
  },
  nextTier: {
    borderRadius: theme.radius.medium,
    background: theme.colors.Background5,
    border: "0 solid var(--Color-Border-bd-1, rgba(255, 255, 255, 0.20))",
    width: "-webkit-fill-available",
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: 10,
  },
  nextTierWrapper: {
    display: "flex",
    width: "278px",
    height: theme.spacing.space48,
    alignItems: "center",
    gap: theme.spacing.space8,
  },
  nextTierImage: {
    // width: "40px",
    height: theme.spacing.space40,
    flexShrink: 0,
  },
  nextTierContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space4,
    textAlign: "start",
  },
  progress: {
    display: "flex",
    width: "100%",
    gap: theme.spacing.space8,
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "stretch",
  },
  progressBar: {
    display: "flex",
    padding: theme.spacing.space2,
    alignItems: "flex-start",
    gap: "10px",
    flex: "1 0 0",
    borderRadius: theme.radius.large,
    background: theme.colors.Background5,
  },
  achievementDetailButtons: {
    width: "303px",
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing.space16,
    height: "50px",
    alignItems: "center",
  },
  btnContent: {
    display: "flex",
    padding: "12px 20px",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    letterSpacing: "-0.9px",
    borderRadius: theme.spacing.space2,
    lineHeight: "21.6px",
  },
  nextTierTitle: {
    textTransform: "uppercase",
  },
}));
